import { useQueries } from "@tanstack/react-query";
import type { SmartField_Api_Contracts_Sensor_DimSensorDto } from "../../api";
import { sensorGetPlacementHistory } from "../../api";

export type PlacementHistoryEntry = Awaited<
	ReturnType<typeof sensorGetPlacementHistory>
>[number] & {
	sensorId: number;
	sensorLabel: string;
};

function sensorLabel(sensor: SmartField_Api_Contracts_Sensor_DimSensorDto): string {
	return sensor.friendlyName ?? `Channel ${sensor.channelNumber}`;
}

export function usePlacementHistoryForSensors(
	sensors: SmartField_Api_Contracts_Sensor_DimSensorDto[],
) {
	const results = useQueries({
		queries: sensors.map((sensor) => ({
			queryKey: ["sensor-placement-history", sensor.id],
			queryFn: () => sensorGetPlacementHistory({ id: sensor.id! }),
			enabled: sensor.id != null,
		})),
	});

	const entries: PlacementHistoryEntry[] = results.flatMap((result, i) => {
		const sensor = sensors[i]!;
		return (result.data ?? []).map((entry) => ({
			...entry,
			sensorId: sensor.id!,
			sensorLabel: sensorLabel(sensor),
		}));
	});

	return {
		entries,
		isLoading: results.some((r) => r.isLoading),
		isError: results.some((r) => r.isError),
	};
}
